import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { AllService } from '../../../services/all.service';
import { TelegramService } from '../../page-telegram/telegram.service';
import { WebsocketService } from '../../../services/websocket';
import { VkService } from '../../page-vk/vk.service';
import { WhatsappService } from '../../page-whatsapp/whatsapp.service';

@Component({
  selector: 'app-page-start-content',
  templateUrl: './page-start-content.component.html',
  styleUrls: ['./page-start-content.component.scss']
})
export class PageStartContentComponent implements OnInit {
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    navText: ['', ''],
    items: 1,
    nav: false
  };
  constructor() {}

  ngOnInit(): void {}
}
